"use client";

import { useEffect, useRef } from "react";

// https://www.joshwcomeau.com/snippets/react-hooks/use-interval/
export const useInterval = (
  callback: any,
  delay: number | null | undefined
) => {
  const intervalRef = useRef<number | undefined>();
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current();
    if (typeof delay === "number") {
      intervalRef.current = window.setInterval(tick, delay);
      return () => window.clearInterval(intervalRef.current);
    }
  }, [delay]);

  return intervalRef;
};
